import { render, staticRenderFns } from "./AutoplaySection.vue?vue&type=template&id=6fae6468&scoped=true"
import script from "./AutoplaySection.vue?vue&type=script&lang=js"
export * from "./AutoplaySection.vue?vue&type=script&lang=js"
import style0 from "./AutoplaySection.vue?vue&type=style&index=0&id=6fae6468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae6468",
  null
  
)

export default component.exports